import React from 'react';
import './gallery.css';

import Daw from '../../assets/pic1.png';
import Notes from '../../assets/pic2.png';
import Me from '../../assets/pic3.png'
import AlbumCover from '../../assets/the_valley_album_cover.png';

const Gallery = () => {
	return (
        <div className="gallery-container">
            <h3 className="title m-auto"><span className="add-bb">Gallery</span></h3>
            <div className="gallery m-auto">
                <div className="pic">
                    <img className="gallery-img" src={AlbumCover} />
                    <p>The Valley Album Cover Concept</p>
                </div>
                <div className="pic">
                    <img className="gallery-img" src={Notes} />
                    <p>Writing melodies & harmonies</p>
                </div>
                <div className="pic">
                    <img className="gallery-img" src={Daw} />
                    <p>One of the late night recording sessions.</p>
                </div>
                <div className="pic">
                    <img className="gallery-img" src={Me} />
                    <p>Mauricio, the writer.</p>
                </div>
            </div>
        </div>
    )
}

export default Gallery;
